function checkOverlappingRectangles(coordsA, coordsB) {
  return ((coordsA[0] < coordsB[2]) && (coordsA[2] > coordsB[0]) && (coordsA[1] < coordsB[3]) && (coordsA[3] > coordsB[1]))
}

module.exports = checkOverlappingRectangles;


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-settings-check/utils/checkOverlappingRectangles.js
// module id = 854
// module chunks = 0